import { render, staticRenderFns } from "./Body.vue?vue&type=template&id=09699636&scoped=true&"
import script from "./Body.vue?vue&type=script&lang=ts&"
export * from "./Body.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09699636",
  null
  
)

export default component.exports